import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { DTypeCol } from '@grupo-constant/next-dtype/types';
import { Observable, of } from 'rxjs';
import { DtypeFieldsRegistry } from '../dtype-fields.registry';
import { MasterData } from '../../master-data/master-data.types';

@Component({
    selector: 'dtype-preview-table',
    templateUrl: 'dtype-preview-table.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class DtypePreviewTableComponent implements OnInit {

    @Input() dtype: MasterData;

    columns: { id: string; dTypeColumn: DTypeCol }[];

    items$: Observable<any>;

    constructor() { }

    ngOnInit() {
        this.columns = this.dtype.columnsForList.map((colName) => {
            const column = (this.dtype.column as DTypeCol[]).find(col => col.name === colName);
            return { id: colName, dTypeColumn: column };
        });

        //if no visible columns show them all
        if (this.columns.length === 0) {
            this.columns = (this.dtype.column as DTypeCol[])
                .filter(c => this.dtype.availableColumnsForList.includes(c.name))
                .map(column => ({ id: column.name, dTypeColumn: column }));
        }

        this.items$ = of(this.generateItems());
    }

    private generateItems() {
        const rows = 15;
        const result = [];

        for (let i = 0; i < rows; i++) {
            const row = {};
            for (const column of this.columns) {
                switch (DtypeFieldsRegistry.getFieldType(column.dTypeColumn)) {
                    case 'text':
                    case 'localetext':
                        row[column.id] = `example_text_${Math.floor(Math.random() * 101)}`;
                        break;

                    case 'number':
                        row[column.id] = Math.floor(Math.random() * 101);
                        break;

                    case 'checkbox':
                        row[column.id] = Boolean(Math.random() >= 0.5);
                        break;

                    default:
                        row[column.id] = `example_data_${Math.floor(Math.random() * 1001)}`;
                        break;
                }
            }
            result.push(row);
        }
        return result;
    }

}
